<div class="flex min-h-screen flex-col justify-between">
  <div class="flex flex-col flex-grow">
    <ng-container *ngIf="!notFound">
      <header class="bg-gray-100 pt-10 pb-6 text-center">
        <h1 class="text-3xl font-semibold">Ticket Info</h1>
      </header>
      <main class="py-4 px-3 flex-grow flex flex-col">
        <ng-container *ngIf="!loadingTicket; else spinner">
          <p
            class="text-center font-semibold text-red-500 mb-4"
            *ngIf="!ticket.checkedInAt; else checkedIn"
          >
            Not Checked In
          </p>
          <ng-template #checkedIn>
            <p
              class="flex items-center justify-center text-center font-semibold text-green-500 mb-4"
            >
              <tix-icon svgIcon="check-circle" class="mr-2"></tix-icon>
              <span>
                Checked In at {{ formatCheckedInAt(ticket.checkedInAt) }}
              </span>
            </p>
          </ng-template>

          <div class="flex items-center justify-between">
            <div
              class="rounded-full inline-block text-center text-sm text-primary border-primary border-2 py-0.5 px-5 font-medium"
            >
              {{ ticket.ticketType }}
            </div>

            <div>
              <p class="text-right font-medium text-gray-400 opacity-80">
                Reservation #{{ ticket.reservationNo }}
              </p>

              <p class="text-right font-medium text-gray-400 opacity-80">
                Ticket #{{ ticket.ticketNo }}
              </p>
            </div>
          </div>

          <h2 class="text-2xl font-semibold mb-1 mt-1">
            {{ ticket.contact?.fullName }}
          </h2>
          <p class="text-gray-400">{{ ticket.contact?.emailAddress }}</p>
          <p class="text-gray-400">
            {{ ticket.contact?.phoneNumbers?.[0]?.phoneNumber?.phoneNumber }}
          </p>

          <h3 class="text-xl font-semibold mb-1 mt-4">
            {{ ticket.event?.name }}
          </h3>
          <p class="text-gray-400">
            {{ ticket.event?.date | date: 'EEEE, MM/dd/YYYY' }}
          </p>
          <p class="text-gray-400">
            <b>Door Opens: </b>
            {{
              ticket.event?.doorsOpen
                ? formatTime(ticket.event?.doorsOpen)
                : 'N/A'
            }}
            <b class="mx-2">|</b> <b>Showtime: </b
            >{{
              ticket.event?.startTime
                ? formatTime(ticket.event?.startTime)
                : 'N/A'
            }}
          </p>
          <p class="text-gray-400">
            {{ ticketData.TicketAggregate.aggregate?.count }} Tickets in
            Reservation
          </p>

          <h4 class="font-bold text-base mt-4 mb-1">
            <span class="text-primary font-black text-2xl">{{
              isFree ? 'Free' : ticket.ticketPrice
            }}</span
            >{{ isFree ? '' : '/Ticket' }}
          </h4>
          <p class="text-gray-400">
            <b>Group Code: </b>{{ ticket.reservation?.groupCode || 'N/A' }}
          </p>
          <div class="flex my-2 justify-end items-center">
            <img
              class="w-10 h-10"
              src="https://www.researchgate.net/publication/288303807/figure/fig1/AS:311239419940864@1451216668048/An-example-of-QR-code.png"
              alt=""
            />
            <h6 class="ml-2 text-2xl font-bold text-right">Scan</h6>
          </div>

          <button
            tix-button
            class="w-full flex items-center !text-lg font-medium h-[4.25rem]"
            (click)="handleUpdateTicket()"
            [disabled]="updatingTicket || updatingReservation"
          >
            <ng-container *ngIf="!updatingTicket; else ticketSpinner">
              <tix-icon svgIcon="user-solid" class="mr-4 scale-150"></tix-icon>
              <ng-container *ngIf="!ticket.checkedInAt; else checkOut"
                >Check In Ticket</ng-container
              >
              <ng-template #checkOut> Check Out Ticket </ng-template>
            </ng-container>

            <ng-template #ticketSpinner>
              <mat-spinner [diameter]="32"></mat-spinner>
            </ng-template>
          </button>

          <button
            tix-button
            class="w-full flex items-center !text-lg font-medium h-16 mt-3"
            (click)="handleUpdateReservation()"
            [disabled]="updatingTicket || updatingReservation"
          >
            <ng-container *ngIf="!updatingReservation; else reservationSpinner">
              <tix-icon
                svgIcon="user-group-solid"
                class="mr-4 scale-150"
              ></tix-icon>

              <ng-container *ngIf="!ticket.checkedInAt">
                Check In Reservation
              </ng-container>
              <ng-container *ngIf="ticket.checkedInAt">
                Check Out Reservation
              </ng-container>
            </ng-container>

            <ng-template #reservationSpinner>
              <mat-spinner [diameter]="32"></mat-spinner>
            </ng-template>
          </button>
        </ng-container>

        <ng-template #spinner>
          <div class="flex-grow flex items-center justify-center">
            <mat-spinner [diameter]="64"></mat-spinner>
          </div>
        </ng-template>
      </main>
    </ng-container>

    <ng-container *ngIf="notFound">
      <div class="flex-grow flex items-center justify-center">
        <h3 class="text-2xl">The URL you followed is invalid</h3>
      </div>
    </ng-container>
  </div>

  <footer
    class="px-5 py-3 text-white bg-primary flex items-center justify-center"
  >
    <p class="mr-4">Powered by:</p>
    <img
      src="https://asylumtixmedia.sfo3.digitaloceanspaces.com/asylumTix/default_images/asylumTixLogo.jpg"
      alt=""
      class="h-24"
    />
  </footer>
</div>
